// This component is going to be used for the "hide rendering personalization"
export default function EsiNullComponent() {
  return null;
}